import { useMutation, useQueryClient } from '@tanstack/react-query'

import { SellTreezService } from '@/services/sell-treez'
import { useNotify } from '@/hooks'
import { CreateIndexRequest } from '@/models/indices'

const useUpdateSellTreezIndexMappings = ({
  sellTreezId,
  onSuccess,
}: {
  sellTreezId: string
  onSuccess?(): void
}) => {
  const { notifyError, notifySuccess } = useNotify()
  const queryClient = useQueryClient()

  const update = async (data: CreateIndexRequest) => {
    const result = await SellTreezService.updateSellTreezIndexMapping(sellTreezId, data)
    return result.data
  }

  const { mutate: updateIndexMappings, isPending: isUpdating } = useMutation({
    mutationFn: update,
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: ['sell-treez-indexes', sellTreezId] })
      notifySuccess('Index updated successfully')
      onSuccess?.()
    },
    onError: (error) => {
      notifyError(error.message ?? 'There was an error')
    },
  })

  return { updateIndexMappings, isUpdating }
}

export { useUpdateSellTreezIndexMappings }
